import { render } from "./ReviewsList.vue?vue&type=template&id=29aded68&scoped=true"
import script from "./ReviewsList.vue?vue&type=script&lang=js"
export * from "./ReviewsList.vue?vue&type=script&lang=js"

import "./ReviewsList.vue?vue&type=style&index=0&id=29aded68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29aded68"]])

export default __exports__